<template>
  <div>
    <div class="zyk-search-wrapper-box">
      <div class="zyk-search-wrapper">
        <div class="zyk-search-con">
          <div class="h2">
            专业知识库
          </div>
          <div class="ivu-input-wrapper">
             <el-input type="text" placeholder="请输入专业名称" @keyup.enter.native="major_name_search()" clearable v-model="major_name" class="input" />
             <div class="button" @click="major_name_search()">
               搜索
             </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-wrapper">
      <div class="beizhu">
         <div class="text">如您所查的门类（专业大类)、专业类、专业与专业目录有出入，请以专业目录为准。</div>
         <div class="list">
           <div class="ul">
            <div class="li">
              <i class="el-icon-s-operation"></i>
              <a href="https://gaokao.chsi.com.cn/gkxx/zybk/202304/20230420/2278114610.html" target="_blank" class="a">
                本科（普通教育）专业目录
              </a>
            </div>
            <div class="li">
              <i class="el-icon-s-operation"></i>
              <a href="https://gaokao.chsi.com.cn/gkxx/zybk/202103/20210322/2063566695-1.html" target="_blank" class="a">
                本科（职业教育）专业目录
              </a>
            </div>
            <div class="li">
              <i class="el-icon-s-operation"></i>
              <a href="https://gaokao.chsi.com.cn/gkxx/zcdh/202103/20210322/2041286243.html" target="_blank" class="a">
                高职（专科）专业目录
              </a>
            </div>
           </div>
         </div>
      </div>
      <div class="index-cc-list">
        <div class="ul" style="margin-top: 30px">
          <div
            class="li"
            @click="formClick('本科')"
            :class="[form.cengci == '本科' ? 'selected' : '']">
            本科（普通教育）
          </div>
          <div
            class="li"
            @click="formClick('本科（职业教育）')"
            :class="[form.cengci == '本科（职业教育）' ? 'selected' : '']">
            本科（职业教育）
          </div>
          <div
            class="li"
            @click="formClick('专科（高职）')"
            :class="[form.cengci == '专科（高职）' ? 'selected' : '']">
            专科（高职）
          </div>
          <div>
          </div>
        </div>
      </div>

      <div
        v-if="major_name"
        class="spec-list"
        style="padding: 20px; margin-bottom: 30px">
        <el-table :data="zhuan" style="width: 100%">
          <el-table-column label="专业名称">
            <template slot-scope="scope">
              <el-button type="text"  @click="majorDetail(scope.row)">
                <span style="font-size: 16px;color: #1db278;">
                        {{ scope.row.major_name }}
                      </span>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="专业代码">
            <template slot-scope="scope">
              <span style="font-size: 16px;">
                {{ scope.row.major_code }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="层次">
            <template slot-scope="scope">
              {{ scope.row.cengci }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="spec-list" v-if="!major_name">
        <div class="zyk-lb-ul-con" v-loading="loading">
          <div class="zyk-lb-title">门类</div>
          <div class="zyk-lb-ul">
            <div
              class="li"
              @click="menleiClick(item)"
              :class="[item == form.subject ? 'selected' : '']"
              v-for="(item, i) in one"
              :key="i">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="zyk-lb-ul-con">
          <div class="zyk-lb-title">专业类</div>
          <div class="zyk-lb-ul">
            <div
              class="li"
              @click="zhuanye(item)"
              :class="[item == form.majors ? 'selected' : '']"
              v-for="(item, i) in two"
              :key="i">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="zyk-table-con">
          <div class="ivu-table-wrapper">
            <div class="ivu-table ivu-table-default">
              <el-table :data="list" style="width: 100%">
                <el-table-column label="专业名称" style="cursor: pointer">
                  <template slot-scope="scope">
                    <el-button type="text" @click="majorDetail(scope.row)">
                      <span style="font-size: 16px;color: #1db278;">
                        {{ scope.row.major_name }}
                      </span>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="专业代码">
                  <template slot-scope="scope">
                    <span style="font-size: 16px;">
                {{ scope.row.major_code }}
              </span>
                  </template>
                </el-table-column>
                <el-table-column label="开设院校">
                  <template slot-scope="scope">
                    <el-button type="text" @click="kaishe(scope.row)"  style="font-size: 16px;color: #1db278;">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <collegeVue ref="collegeData" />
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import {
  selectMajorForm,
  selectOneMajor,
  selectMajorList,
} from "@/api/gw/major.js";
import { major_name_search } from "@/api/gw/zonghe.js";
import collegeVue from "./components/college.vue"
export default {
  components:{
      collegeVue,
    },
  computed: {
    ...mapGetters(['isLogin',"userinfo"]),
  },
  data() {
    return {
      form: {
        cengci: "本科",
        subject: "", //当前选中门类
        majors: "", //一级学科
      },
      major_name: "", //专业名称
      one: [], //门类
      two: [], //一级学科
      list: [],
      loading: false,

      zhuan: [], //专业的列表
      i:null,
    };
  },
  mounted() {
    this.i = this.$route.query.i || null;
    if(localStorage.getItem("qichengUserToken")){
      this.$store.dispatch("getUserInfo");
    }
    this.selectMajorForm(); //门类
    console.log('userinfo',this.userinfo)
  },
  watch:{
    major_name(e){
      if(e){
        this.major_name_search();
      }else{
        this.zhuan = [];
        this.selectMajorForm();
      }
    },
  },
  methods: {
    kaishe(item){
       this.$refs.collegeData.show(item);
    },
    major_name_search() {
      major_name_search({
        major_name: this.major_name,
        cengci:this.form.cengci
      }).then((res) => {
        let arr = [];
        arr = res.data.filter((r)=>{
           return r.major_code;
        })
        this.zhuan = arr;
      });
    },
    formClick(title) {
      this.form.cengci = title;
      if(this.major_name){
         this.major_name_search();
      }else{
        this.selectMajorForm();
      }
    },
    menleiClick(title) {
      this.form.subject = title;
      this.selectOneMajor();
    },
    zhuanye(title) {
      this.form.majors = title;
      this.selectMajorList();
    },
    //专业详情
    majorDetail(row) {
      let isCha=0;
      if(this.userinfo&&this.userinfo.role!=1){
        isCha=1
      }
      this.$router.push({
        path: "/MajorDetail",
        query: {
          n: row.mojor_id,
          i:this.i || 12540,
          isCha
        },
      });
    },
    //门类
    selectMajorForm() {
      this.loading = true;
      this.one = [];
      this.two = [];
      this.list = [];
      selectMajorForm({
        cengci: this.form.cengci,
      })
        .then((res) => {
          console.log("门类", res.data);
          this.one = res.data;
          this.form.subject = res.data.length > 0 ? res.data[0] : "";
          this.selectOneMajor(); //查询一级学科
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //一级学科
    selectOneMajor() {
      this.loading = true;
      this.two = [];
      this.list = [];
      selectOneMajor({
        subject: this.form.subject,
      })
        .then((res) => {
          console.log("一级学科门类", res.data);
          this.two = res.data;
          this.form.majors = res.data.length > 0 ? res.data[0] : "";
          this.selectMajorList(); //查询专业
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectMajorList() {
      this.loading = false;
      // this.two = []
      this.list = [];
      selectMajorList({
        subject: this.form.subject,
        majors: this.form.majors,
      })
        .then((res) => {
          console.log("专业", res.data);
          this.list = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './scss/index.scss';
::v-deep .inputs .el-input__inner {
  height: 42px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/major/index.vue